module.exports = __webpack_public_path__ + "static/media/bg-congratulation-a.259949a2.png";